import { render, staticRenderFns } from "./equalarm.vue?vue&type=template&id=66bfe52f&scoped=true&"
import script from "./equalarm.vue?vue&type=script&lang=js&"
export * from "./equalarm.vue?vue&type=script&lang=js&"
import style0 from "./equalarm.vue?vue&type=style&index=0&id=66bfe52f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bfe52f",
  null
  
)

export default component.exports